import { IApiStandardResponse } from './api-response.model';

/**
 * Credenziali di login
 */
export interface ILoginCredentials {
  username: string;
  password: string;
  device_name?: string;
  device_id?: string;
}

/**
 * Classe per le credenziali di login
 */
export class LoginCredentials {
  username: string;
  password: string;
  device_name?: string;
  device_id?: string;

  constructor(credentials: ILoginCredentials) {
    this.username = credentials.username;
    this.password = credentials.password;
    this.device_name = credentials.device_name;
    this.device_id = credentials.device_id;
  }

  toJson(): ILoginCredentials {
    return {
      username: this.username,
      password: this.password,
      device_name: this.device_name,
      device_id: this.device_id
    };
  }

  toFormData(): FormData {
    const formData = new FormData();
    formData.append('username', this.username);
    formData.append('password', this.password);
    if (this.device_name) {
      formData.append('device_name', this.device_name);
    }
    if (this.device_id) {
      formData.append('device_id', this.device_id);
    }
    return formData;
  }
}

/**
 * Risposta del login
 */
export interface ILoginResponse {
  token_id: string;
  token: string;
  token_exiration_minutes: string;
  refresh_token: string;
  token_type: string;
}

/** Valore predefinito per `app_source` nelle richieste di reset password. */
export const RESET_PWD_APP_SOURCE = 'sso';

/**
 * Richiesta reset password
 */
export interface IResetPWD {
  username: string;
  device_name: string;
  app_source?: string;
}

/**
 * Risposta reset password
 */
export interface IResetPWDResponse extends IApiStandardResponse<string> {}

/**
 * Dati del token
 */
export interface ITokenData {
  token_id: string;
  token: string;
  token_expiration_minutes: string;
  refresh_token: string;
  token_type: string;
}

/**
 * Token
 */
export interface IToken {
  token_id: string;
  token: string;
  token_expiration_minutes: string;
  refresh_token: string;
  token_type: string;
}

/**
 * Risposta API con token
 */
export interface IApiToken extends IApiStandardResponse<IToken> {}
